import styled from "styled-components";

import { Dialog } from "@libraries/mui";

import { windowWidth } from "@styles/global";

const Container = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 10px !important;
    min-width: 400px !important;

    @media (max-width: ${windowWidth.mobile.large}) {
      min-width: 95% !important;
    }
  }

  .MuiDialogContent-root {
    padding: 0px 24px;
  }

  #printInvoiceDialog-content {
    padding-left: 36px;
  }

  #printInvoiceDialog-description {
    > :first-child {
      padding-bottom: 12px;
    }

    > :nth-child(2) {
      padding-top: 18px;
      border-top: 2px solid #e0e0e0;
    }
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  color: #000;
`;

const ContentIcon = styled.div`
  margin-right: 16px;

  svg {
    fill: #64dd17;
  }
`;

const DialogActions = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  button {
    color: #9400ee;
  }
`;

export { Container, Content, ContentIcon, DialogActions };
